import { render, staticRenderFns } from "./video_player.vue?vue&type=template&id=3ca26fe8&"
import script from "./video_player.vue?vue&type=script&lang=js&"
export * from "./video_player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports